import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    disableBackdropClose: Boolean,
    resetOnClose: Boolean,
    headerId: String,
    frameId: String,
    titleId: String,
  }

  DIALOG_OPEN_CLASS = 'components--modal__dialog--open'
  FRAME_LOADING_CLASS = 'components--modal__frame--loading'

  connect() {
    // reset turbo frame content on successful form submission, so that the DOM resets
    // this is designed to work whether the form is rendered with the layout or loaded asynchronously
    this.initialHeader = this.getHeader().cloneNode(true)
    this.initialFrame = this.getFrame().cloneNode(true)

    // use 'mousedown' instead of click to prevent button clicks that 
    // accidentally drag and non-mouse 'click' triggers
    this.element.addEventListener('mousedown', event => {
      const { target, currentTarget, clientY, clientX } = event

      if (!this.disableBackdropCloseValue) {
        // do not close IF click coords are within bounds of modal dialog
        const rect = currentTarget.getBoundingClientRect()
        const isInDialog =
          rect.top <= clientY &&
          rect.left <= clientX &&
          clientY <= rect.top + rect.height &&
          clientX <= rect.left + rect.width
        if (isInDialog) return;
        // do not close IF click is outside bounds, but target is contained by modal (e.g. datepicker, dropdown)
        if (currentTarget !== target && currentTarget.contains(target)) return;

        this.handleClose()
      }
    })

    this.element.addEventListener('close', () => {
      this.element.classList.remove(this.DIALOG_OPEN_CLASS)
      // give a bit of time for animation to play before hiding
      setTimeout(() => (this.element.hidden = true), 200)
      document.activeElement.focus({ focusVisible: true })

      if (this.resetOnCloseValue) this._reset()
    })

    this.element.addEventListener('turbo:frame-load', e => {
      ReactRailsUJS.mountComponents(this.element)
      e.target.classList.remove(this.FRAME_LOADING_CLASS)
    })


    this.element.addEventListener('turbo:submit-end', e => {
      const { success, fetchResponse } = e.detail
      if (success) {
        const keepOpenHeaderValue = fetchResponse.response.headers.get('x-monami-modal-keep-open')
        if (!keepOpenHeaderValue) {
          // return modal to original state after form submission
          this.handleClose()
          this._reset()
        }
      }
    })

    this.element.addEventListener('turbo:click', ({ target }) => {
      this.getFrame().classList.add('components--modal__frame--loading')
      const newTitle = target.getAttribute('data-modal-title')
      if (newTitle) {
        this.getTitle().innerHTML = newTitle
      }
    })
  }

  handleClose = () => {
    if ('requestClose' in this.element) {
      this.element.requestClose()
    } else {
      this.element.close()
    }
  }

  getTitle = () => {
    return this._getById(this.titleIdValue)
  }

  getHeader = () => {
    return this._getById(this.headerIdValue)
  }

  getFrame = () => {
    return this._getById(this.frameIdValue)
  }

  _getById = (id) => {
    return this.element.querySelector(`#${id}`)
  }

  _reset = () => {
    setTimeout(() => {
      this.getHeader().replaceWith(this.initialHeader)
      this.initialHeader = this.getHeader().cloneNode(true)
      this.getFrame().replaceWith(this.initialFrame)
      this.initialFrame = this.getFrame().cloneNode(true)
    }, 200)
  }
}
